import RXGatePage from './RXGatePage';
import rxGatePageReducer from './reducer';

export { rxGatePageReducer };
export default RXGatePage;
